import React, { useState } from 'react';
import { Form, Button, ListGroup, InputGroup, Row, Col } from 'react-bootstrap';
import { Base } from '../../components/RootLayout';
import TopNavigation from '../../components/TopNavigation';
import * as Assets from '../../utils/svg_assets';
import './style.scss';

const SearchBox = (props) => {
  const {
    onClose,
    isMultipleSelected = false,
    type,
    datas = [],
    selectedItem = () => {},
  } = props;

  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const handleToggle = (itemId) => {
    if (isMultipleSelected) {
      const currentIndex = selectedItems.indexOf(itemId);
      const newSelectedItems = [...selectedItems];

      if (currentIndex === -1) {
        newSelectedItems.push(itemId);
      } else {
        newSelectedItems.splice(currentIndex, 1);
      }

      setSelectedItems(newSelectedItems);
    } else {
      const selectedData = {
        type,
        selectedItems: [itemId],
      };
      selectedItem(selectedData);
    }
  };

  const handleSubmit = () => {
    const selectedData = {
      type,
      selectedItems,
    };
    selectedItem(selectedData);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredItems = datas.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Base>
      <TopNavigation
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        onClick={onClose}
      />
      <div className="container mt-4">
        <InputGroup className="mb-3">
          <Form.Control
            placeholder="Search"
            aria-label="Search"
            aria-describedby="basic-addon1"
            value={searchTerm}
            onChange={handleSearch}
          />
        </InputGroup>
        <ListGroup variant="flush">
          {filteredItems.map((item) => (
            <ListGroup.Item
              key={item.id}
              className="d-flex justify-content-between align-items-center list-item"
              onClick={() => handleToggle(item.id)}
            >
              <span>{item.name}</span>
              {isMultipleSelected ? (
                <Form.Check
                  type="checkbox"
                  checked={selectedItems.includes(item.id)}
                  onChange={() => handleToggle(item.id)}
                  className={
                    selectedItems.includes(item.id)
                      ? 'checkbox selected'
                      : 'checkbox'
                  }
                />
              ) : (
                ''
              )}
            </ListGroup.Item>
          ))}
        </ListGroup>
        {isMultipleSelected ? (
          <Row className="footer">
            <Col>
              <Button
                variant="outline-danger"
                className="w-100"
                onClick={() => setSelectedItems([])}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button variant="danger" className="w-100" onClick={handleSubmit}>
                Submit
              </Button>
            </Col>
          </Row>
        ) : (
          ''
        )}
      </div>
    </Base>
  );
};

export default SearchBox;
